import { forwardRef } from "react";
import { ModalProps } from "@mui/material";

export const withModelWrapper = <P extends object>(
  ModalWrapperComponent: React.ComponentType<P>,
  OverlayComponent: React.ComponentType<any>,
) => {
  return forwardRef<any, React.PropsWithChildren<P & ModalProps>>(
    ({ open, onClose, children, ...props }, ref) => {
      return (
        // <OverlayComponent>
        <ModalWrapperComponent open={open} onClose={onClose} {...(props as P)} ref={ref}>
          {children}
        </ModalWrapperComponent>
        // </OverlayComponent>
      );
    },
  );
};
